exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3hdNkXaDcCfOI5bRRvKxZn{text-align:left}.xdDjLkX4_yUFARSOCnvKz{text-align:center}.NBH8yyQ_cBNbUk5Y9rhf{text-align:right}\n", ""]);

// exports
exports.locals = {
	"left": "_3hdNkXaDcCfOI5bRRvKxZn",
	"center": "xdDjLkX4_yUFARSOCnvKz",
	"right": "NBH8yyQ_cBNbUk5Y9rhf"
};